/* DistCenterStatusComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./DistCenterStatusRenderer");

const _ = require("lodash");

const GSO_ID = "565a65db-54e7-4461-a954-f0f38f310e19";
//const PollInterval = 30000;

class DistCenterStatusComponent extends EventEmitter {
    constructor(logger, eventEmitter, SystemConfig) {
        super();
        this._logger = logger;
        this._eventEmitter = eventEmitter;
        this._SystemConfig = SystemConfig;

        this._systemConfigEntity = undefined;
        this._httpConfig = undefined;
        this._updatedConnectionConfig = undefined;

        this._registerListeners();
        this._renderer = new Renderer(this);
        this.whenModelIsReady();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}

    _testConnection(that) {
        //Do we even want to connect?
        if (!this._systemConfigEntity.enableDistributionCenter) {
            that.emit("DSGUpdate", "Not Connected");
            return false;
        }
        //Try and report
        return that._SystemConfig
            .testDistributionCenterConnection(that._updatedConnectionConfig)
            .then((response) => {
                let message = "Not Connected";
                if (response) {
                    if (response.result && response.result.toLowerCase() === "error") {
                        if (typeof response.error === "string") {
                            message = response.error;
                        } else {
                            message = _.get(
                                response,
                                "error.error",
                                "Failed to connect to Gluware Distribution Center."
                            );
                        }
                    } else {
                        message = "Connected";
                    }
                }
                that.emit("DSGUpdate", message);
            })
            .catch((e) => {
                console.log(e, "failed to connect to GDC");
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/

    async whenModelIsReady() {
        this._systemConfigEntity = await this.getSystemConfig();
        this._httpConfig = this._SystemConfig._cleanHttpConfig(
            this._systemConfigEntity.getHttpConfig()
        );
        this._updatedConnectionConfig = _.cloneDeep(this._httpConfig);
        this._testConnection(this);
        //Leaving in case we do want some monitoring in future
        //this._continousCheck = setInterval(this._testConnection, PollInterval, this);
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._renderer.rootElement;
    }

    get logger() {
        return this.getLogger();
    }
    getLogger() {
        return this._logger;
    }

    getSystemConfig() {
        return this._SystemConfig.loadSystemConfig(GSO_ID);
    }

    render() {
        return this._renderer.render();
    }

    shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();
        this.removeAllListeners();
        if (this._continousCheck) {
            clearInterval(this._continousCheck);
        }
        return Promise.all([this._renderer.shutdown()]).then(
            () => {
                this._renderer = undefined;
                this._logger = undefined;
                this._userSession = undefined;
                this._SystemConfig = undefined;
                this._httpConfig = undefined;
                this._updatedConnectionConfig = undefined;
            },
            (error) => {
                this._logger.warn({error}, "ContentServerStatusComponent.shutdown error");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    /**
     * @param {Array} servers
     */
    setServers(servers) {
        this.emit("Servers", _.toArray(servers));
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = DistCenterStatusComponent;

DistCenterStatusComponent.$inject = [
    "$teve.logger",
    "eventEmitter.eventEmitter",
    "$teve.entities.SystemConfig",
];

DistCenterStatusComponent.$displayDetails = {
    type: "View",
    name: "",
    icon: "common.duplicate",
    shown: false,
    order: 2,
};
